import moment from 'moment';
import 'moment-timezone';

// The operational "stocking day" is not a calendar day: it runs from 6 PM
// America/Chicago on the previous calendar day to 6 PM Chicago on the stocking
// date, bounds `[)` (start inclusive, end exclusive). PM routes scan overnight,
// so the window deliberately straddles midnight — which is also why every
// consumer fetches the stocking date AND the day before before filtering.
//
// Single source of truth for the cutoff: `libs/stopStatus`, `libs/driverActions`,
// `hooks/useDriverLocationsPoll` and `containers/ViewStockingDashboard` all
// resolve the window through here, so moving the cutoff is a one-line change.
const STOCKING_DAY_CUTOFF_HOUR = 18;
const STOCKING_DAY_TIMEZONE = 'America/Chicago';

const CUTOFF = {
  hour: STOCKING_DAY_CUTOFF_HOUR,
  minute: 0,
  second: 0,
  millisecond: 0,
};

// The window's UTC bounds as moments, for a "YYYY-MM-DD" stocking date.
export function getStockingWindowUtc(stockingDate) {
  const dayInChicago = moment.tz(
    stockingDate,
    'YYYY-MM-DD',
    STOCKING_DAY_TIMEZONE,
  );
  return {
    start: dayInChicago.clone().subtract(1, 'day').set(CUTOFF).utc(),
    end: dayInChicago.clone().set(CUTOFF).utc(),
  };
}

// Keep only the driver-action events that fall inside the stocking day.
// Driver-action `_lastModified` is a Unix timestamp in SECONDS;
// null/undefined/malformed timestamps fall outside the window.
// Filtering is per-item, so callers may filter before or after merging event
// families without changing the result.
export function filterEventsByDate(items, stockingDate) {
  const { start, end } = getStockingWindowUtc(stockingDate);
  return (items || []).filter((item) =>
    moment.unix(item && item._lastModified).isBetween(start, end, null, '[)'),
  );
}

// "YYYY-MM-DD" for the calendar day before the stocking date — the second
// slice every driver-action fetch needs to cover the overnight overlap.
export function previousStockingDate(stockingDate) {
  return moment(stockingDate, 'YYYY-MM-DD')
    .subtract(1, 'day')
    .format('YYYY-MM-DD');
}
